// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__3VQWS","active":"downloadDropdown_active__1ae1k"};